import React from "react";
import "./TotalPrice.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";

const TotalPrice: React.FC = () => {
  const { totalPrice } = useConfiguration();

  return (
    <div className="configurator-total-price">
      <span>{totalPrice}</span>
      <p>incl. BTW</p>
    </div>
  );
};

export default TotalPrice;
